<template>
  <div class="contact-us-wrapper">
    <div class="title">If you are interested in us</div>

    <div class="contact-email-wrapper">
      <div class="wrapper">
        <img class="contact-email-bg" :src="source('contact-card')" alt="">

        <div class="content-wrapper">
          <div class="top-label">We provide mutual exchange and learning. If you are more interested in this aspect, you
            can come to us for
            exchange and learning.
          </div>

          <div class="divider"/>

          <div class="sub-label">If you'd like to join us, please fill in your email here!</div>

          <div class="input-wrapper">
            <input class="input" type="text" placeholder="Enter your email"
                   v-model="emailAddress" @keyup.enter="sendEmail"/>
            <div class="arrow-icon" @click="sendEmail">
              <img class="arrow" :src="source('contact-arrow-right')" alt="">
            </div>
          </div>
          <div class="err-msg" v-if="errMsg">{{ errMsg }}</div>

          <div class="view-more-button" @click="toPage('/contact')" >
            <span class="sssss" ref="viewMoreRef">VIEW MORE</span>
          </div>
          <!-- <img class="view-more-button" ref="viewMoreRef" :src="source('contact-us-view-more')"
               @click="toPage('/contact')" alt="VIEW MORE"> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import key from "@/api/key";
import emailUtil from "@/utils/email";

export default {
  name: 'contact-us',
  data() {
    return {
      emailAddress: '',
      errMsg: ''
    }
  },
  mounted() {
    const viewMoreEl = this.$refs.viewMoreRef
    const ob = new IntersectionObserver(e => {
      viewMoreEl.className = e[0].isIntersecting ? 'sssss animate__animated animate__flipInY' : 'sssss'
    })
    ob.observe(viewMoreEl)
  },
  watch: {
    emailAddress(newVal) {
      if (newVal !== '') {
        this.errMsg = emailUtil.check(newVal) ? '' : 'Incorrect email format!'
      }
    }
  },
  methods: {
    async sendEmail() {
      if (!emailUtil.check(this.emailAddress)) {
        this.errMsg = 'Incorrect email format!'
        return
      }
      emailUtil.send(this.emailAddress, 'Home来源页用户未填写', 'Home来源页用户未填写').then(res => {
        this.emailAddress = ''
        this.errMsg = ''
      }).catch(err => {
        this.errMsg = err.text
      })
    },
    source(name) {
      return key.getByName(key.HOME_CONTACT, name).fileUrl
    },
  }
}
</script>

<style scoped lang="scss">

.contact-us-wrapper {
  overflow: hidden;
  background-color: black;

  .title {
    margin-top: 7.24vw;
    margin-left: 5.26vw;
    width: 39vw;
    font-size: 5vw;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 5vw;
  }

  .contact-email-wrapper {
    margin-top: 4.115vw;
    margin-bottom: 9.323vw;
    display: flex;
    justify-content: center;

    .wrapper {
      position: relative;

      .contact-email-bg {
        width: 60.729vw;
        height: 56.71875vw;
      }

      .content-wrapper {
        position: absolute;
        top: 15.104vw;
        left: 2.968vw;
        right: 2.968vw;

        .top-label {
          font-size: 2.083vw;
          color: #FFFFFF;
          line-height: 2.5vw;
        }

        .divider {
          margin-top: 1.667vw;
          margin-bottom: 3.229vw;
          width: 100%;
          height: 0.104vw;
          background-image: linear-gradient(to right, #FFF 65%, rgba(0, 0, 0, 0) 0%);
          background-position: bottom;
          background-size: 1.042vw 0.104vw; /* 第一个参数设置虚线点的间距；第二个参数设置虚线点y轴上的长度 */
          background-repeat: repeat-x;
        }

        .sub-label {
          font-size: 2.083vw;
          color: #FFFFFF;
          line-height: 2.5vw;
        }

        .input-wrapper {
          margin-top: 4.167vw;
          display: flex;
          width: 53.385vw;
          height: 5.156vw;
          border: 0.052vw solid rgba(255, 255, 255, 0.5);

          .input {
            flex: 1;
            padding: 1.771vw;
            border: none;
            outline: none;
            background-color: #0000ff;
            font-size: 1.667vw;
            color: white;
          }

          .arrow-icon {
            margin: 0.781vw 1.718vw;
            width: 3.542vw;
            height: 3.542vw;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all .3s;

            .arrow {
              animation: rotate .8s linear infinite;
            }

            &:hover {
              transform: scale(1.2);
              cursor: pointer;
            }

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        .err-msg {
          padding-top: 1vw;
          font-size: 1.667vw;
          color: red;
        }

        .view-more-button {
          margin-top: 5.573vw;
          width: 55.312vw;
          height: 5.521vw;
          display: flex;
          align-items: center;
          border-top: 1PX solid #666;
          border-bottom: 1PX solid #666;
          &:hover {
            cursor: pointer;
          }
          .sssss {
            font-size: 38px;
            font-family: Arial-Bold, Arial;
            font-weight: bold;
            color: #E4E4E4;
            display: inline-block;
            width: 100%;
            text-align: center;
          }
        }
      }
    }
  }
}

@keyframes rotate {
  0%, 100% {
    transform: translateX(-0.5vw);
  }
  50% {
    transform: translateX(0.5vw);
  }
}
</style>
